import {
    CadastrarTipoDocumentoInterface,
    TipoDocumentoInterface,
} from "../../../../Interfaces/Geral/GestaoDeCadastro/TipoDocumento/TipoDocumentoInterface";

import {
    CadastratarTipoDocumentoService,
    DeletarTipoDocumentoService,
    EditarTipoDocumentoService,
    ListarTipoDocumentoService,
    ListarClassificacaoDocumentoService,
} from "../../../../Services/Geral/GestaoDeCadastros/TipoDocumento/TipoDocumentoService";
import { Controller } from "../../../Controller";

export async function CadastratarTipoDocumentoController(
    requestBody: CadastrarTipoDocumentoInterface
) {
    return Controller(CadastratarTipoDocumentoService(requestBody));
}

export async function ListarTipoDocumentoController() {
    return Controller(ListarTipoDocumentoService());
}

export async function ListarClassificacaoDocumentoController() {
    return Controller(ListarClassificacaoDocumentoService());
}

export async function EditarTipoDocumentoController(
    requestBody: TipoDocumentoInterface
) {
    return Controller(EditarTipoDocumentoService(requestBody));
}

export async function DeletarTipoDocumentoController(IDTipoDocumento: number) {
    return Controller(DeletarTipoDocumentoService(IDTipoDocumento));
}
